import { render, staticRenderFns } from "./PostSearchFilters.vue?vue&type=template&id=ff2a7c9c&scoped=true"
import script from "./PostSearchFilters.vue?vue&type=script&lang=js"
export * from "./PostSearchFilters.vue?vue&type=script&lang=js"
import style0 from "./PostSearchFilters.vue?vue&type=style&index=0&id=ff2a7c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2a7c9c",
  null
  
)

export default component.exports